var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deq-reset"},[(_vm.text)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}}):_vm._e(),(_vm.error)?_c('span',[_c('i',{staticClass:"symbol-warning"}),_vm._v(" ERROR LOADING GLOSSARY TERM ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }